var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};



// WEBPACK FOOTER //
// ./C:/Users/Pili/AppData/Roaming/npm/~/pink/~/core-js/modules/_cof.js